import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DMVStoreService } from "../../../services/dmv/dmv-store.service";

import { AppUtil } from "../../../utils/app.util";
import { InsuranceData } from "src/app/models/dmv/insuranceData";
import { GlobalService } from "src/app/services/global/global.service";
@Component({
	selector: "dmv-add-update-insurance",
	templateUrl: "./add-update-insurance.component.html",
	styleUrls: ["./add-update-insurance.component.css"]
})
export class AddUpdateInsuranceComponent implements OnInit {
	constructor(
		private formBuilder: FormBuilder,
		public dmvStoreService: DMVStoreService,
		public globalService: GlobalService
	) {}
	public errorMessage: string = "";
	public submitted = false;
	public insuranceForm: FormGroup;
	public isPopupOpen: boolean = true;
	public insuranceData: InsuranceData = {};

	/*@ViewChild("insuranceCompanyInput", { static: false })
	insuranceCompanyInput: ElementRef;
	@ViewChild("insurancePolicInput", { static: false })
	insurancePolicInput: ElementRef;*/

	@Input() public globalInsuranceData: InsuranceData;
	@Output()
	public closeAddUpdateInsurance: EventEmitter<any> = new EventEmitter();
	@Output() public updateInsurance: EventEmitter<any> = new EventEmitter();
	ngOnInit() {
		AppUtil.log("AddUpdateInsuranceComponent is loaded");
		if (!this.globalInsuranceData) {
			this.globalInsuranceData = {};
		}
		this.insuranceForm = this.formBuilder.group({
			companyName: [
				this.globalInsuranceData.companyName,
				[Validators.required, Validators.pattern(/^[^<=+>:;\/\\@\{\}\[\]?]*$/)]
			],
			companyCode: [
				this.globalInsuranceData.companyCode
					? this.globalInsuranceData.companyCode
					: null,
				[
					Validators.required,
					Validators.pattern(/^(\d{5}|[A-Z]\d[A-Z] *\d[A-Z]\d)$/),
					Validators.maxLength(5)
				]
			],
			policyNumber: [
				this.globalInsuranceData.policyNumber,
				[Validators.required, Validators.pattern(/^[^<=+>:;\/\\@\{\}\[\]?]*$/)]
			],
			insuranceAffidavit: [false, Validators.required]
		});
	}
	public get f() {
		return this.insuranceForm.controls;
	}

	/*public validForinsurancePolic() {
		console.log(this.insurancePolicInput.nativeElement.attributes.size.value);
		if (
			this.insurancePolicInput.nativeElement.attributes &&
			this.insurancePolicInput.nativeElement.attributes.size &&
			this.insurancePolicInput.nativeElement.attributes.size.value &&
			Number(this.insurancePolicInput.nativeElement.attributes.size.value)
		) {
			this.insuranceForm.controls.policyNumber.setValidators([
				Validators.required,
				Validators.maxLength(
					Number(this.insurancePolicInput.nativeElement.attributes.size.value)
				)
			]);
		}
	}

	public validForinsuranceCompanyInput() {
		if (
			this.insuranceCompanyInput.nativeElement.attributes &&
			this.insuranceCompanyInput.nativeElement.attributes.size &&
			this.insuranceCompanyInput.nativeElement.attributes.size.value &&
			Number(this.insuranceCompanyInput.nativeElement.attributes.size.value)
		) {
			this.insuranceForm.controls.companyName.setValidators([
				Validators.required,
				Validators.maxLength(
					Number(this.insuranceCompanyInput.nativeElement.attributes.size.value)
				)
			]);
		}
	}*/

	public addEdit() {
		this.submitted = true;
		if (!this.insuranceForm.controls.insuranceAffidavit.value) {
			this.errorMessage = "Please correct the error indicated below.";
			return;
		}
		this.errorMessage = "";

		if (this.insuranceForm.invalid) {
			return;
		}

		let companyName: string = this.insuranceForm.controls.companyName.value;
		companyName =
			companyName.length > 50 ? companyName.substr(0, 64) : companyName;
		this.insuranceData.companyName = companyName;

		let companyCode: string = this.insuranceForm.controls.companyCode.value;
		companyCode =
			companyCode.length > 5 ? companyCode.substr(0, 5) : companyCode;
		this.insuranceData.companyCode = companyCode;

		let policyNumber: string = this.insuranceForm.controls.policyNumber.value;
		policyNumber =
			policyNumber.length > 20 ? policyNumber.substr(0, 64) : policyNumber;
		this.insuranceData.policyNumber = policyNumber;

		this.isPopupOpen = false;
		this.updateInsurance.emit(this);
		AppUtil.log("AddUpdateInsuranceComponent == > addEdit function submitted");
	}
	public close() {
		this.isPopupOpen = false;
		this.closeAddUpdateInsurance.emit();
	}
}
